import React from 'react'

const Warning = ({ title, message }) => {
  return (
    <div className="border border-warning mb15">
      <div className="modal-header bg-warning">
        <div className="modal-title text-warning">{title}</div>
      </div>
      <div className="modal-body">
        {message}
      </div>
    </div>
  )
};

export default Warning
